import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectTriggerOverview } from "../../CommonComponents/CommonProjectTriggerViews";
export const ProjectTriggerBuiltInFeedRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().builtInFeedTrigger,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectTriggerOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
